import React from "react";
import { foundHerModules } from "./FoundHerData";

const FoundHerAbout = () => {
  const modules = [
    "🏠 OneView",
    "👩 Profile",
    "💜 Purpose",
    "💡 Venture",
    "🚀 Journey",
    "🔥 Streaks",
    "🛍  Marketplace",
    "📦 Orders",
    "💰 Funding",
    "🎁 Support",
    "🎓 Academy",
    "🤝 Mentors",
    "🌐 Network",
    "⭐ TrustBadge",
    "🏆 Challenges",
    "🌟 Spotlight",
    "🎯 Dreams",
    "🏫 Communities",
    "🧰 Resources",
  ];

  return (
    <section className="py-4 px-6 bg-gradient-to-b from-rose-950 via-fuchsia-950 to-purple-950 text-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-md rounded-full px-5 py-2 mb-4">
            <span className="text-pink-300">💜</span>
            <span className="uppercase tracking-[0.25em] text-xs text-rose-100 font-semibold">
              What is FoundHer?
            </span>
          </div>

          <h2 className="text-xl lg:text-2xl font-black tracking-tight mb-4 bg-gradient-to-r from-white via-rose-100 to-pink-200 bg-clip-text text-transparent">
            More Than A Marketplace.<br />A Home For Future Women Founders.
          </h2>

          <p className="max-w-4xl mx-auto text-rose-200 text-sm lg:text-lg leading-relaxed">
            FoundHer is a global ecosystem by <span className="font-semibold text-pink-200">PurpleDoor</span>
            dedicated to helping young women transform ideas into thriving businesses.
            Whether you're starting with a dream, a handmade product, a digital service,
            or a bold innovation, FoundHer gives you the tools, visibility, support,
            mentorship, and community to grow with confidence.
          </p>
        </div>

        {/* Vision Card */}
        <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md p-6 mb-8">
          <div className="text-xl lg:text-2xl mb-4">
            🌸
            <span className="italic text-sm lg:text-lg text-gray-100 ml-3">
              "Every successful business begins with one courageous woman who decides to start."
            </span>
          </div>

          <p className="text-rose-200 text-sm lg:text-lg leading-relaxed">
            FoundHer isn't built to create unicorns overnight.
            It's built to help every young woman earn her first customer,
            build her confidence, grow her community,
            and become a purpose-driven entrepreneur.
          </p>
        </div>

        {/* Future Navigation */}
        <div className="text-center mb-5">
          <h3 className="text-xl lg:text-2xl font-bold mb-2 text-rose-100">
            Everything She Need In One Place
          </h3>
          <h4 className="text-lg lg:text-xl font-bold mb-2 text-gray-300">
            Think5Whys Has Evolving MSME and SHG Modules. Single Source of Truth! One Ecosystem.
          </h4>
          <p className="text-rose-300 text-sm lg:text-lg">
            FoundHer is organised into powerful modules that support every stage of the entrepreneurial journey.
          </p>
        </div>

        {/* Modules */}
        <div className="grid grid-cols-4 lg:grid-cols-8 gap-2">
          {foundHerModules.map((module, index) => (
            <div
              key={index}
              className="rounded-xl border border-pink-400/20 bg-white/5 hover:bg-white/10 transition-all duration-300 px-1 py-1 text-center text-[11px] lg:text-sm font-medium text-rose-100 hover:scale-105"
            >
              {module.icon}{" "}{module.label}
            </div>
          ))}
        </div>

        {/* Footer Statement */}
        <div className="mt-6 rounded-xl bg-gradient-to-r from-pink-600/15 via-fuchsia-600/15 to-purple-600/15 border border-pink-400/20 p-6 text-center">
          <h3 className="text-lg lg:text-xl font-bold mb-3 text-white">
            Find Her. Fund Her. Found Her. Grow Her
          </h3>

          <p className="text-rose-200 text-sm lg:text-lg max-w-3xl mx-auto leading-relaxed">
            Buy from women-led businesses. Mentor aspiring founders.
            Offer your skills. Sponsor dreams. Celebrate achievements.
            Together, we're building the world's most supportive ecosystem
            for the next generation of women entrepreneurs.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FoundHerAbout;